import request from '@/utils/request'

export function ceHotRecruitment() {
    return request({
        url: '/api/recruitment/ceHotRecruitment',
        method: 'get'
    })
}